import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActions = ({ selectedItems, onBulkDelete, onBulkAdjust, onClearSelection }) => {
  const [isAdjusting, setIsAdjusting] = useState(false);
  const [adjustAmount, setAdjustAmount] = useState('');

  const handleBulkAdjust = () => {
    const amount = parseFloat(adjustAmount);
    if (!isNaN(amount) && amount !== 0) {
      onBulkAdjust(amount);
      setAdjustAmount('');
      setIsAdjusting(false);
    }
  };

  if (selectedItems?.length === 0) {
    return null;
  }

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
            <Icon name="CheckSquare" size={20} className="text-primary-foreground" />
          </div>
          <div>
            <p className="text-sm md:text-base font-semibold text-foreground">
              {selectedItems?.length} {selectedItems?.length === 1 ? 'item' : 'items'} selected
            </p>
            <p className="text-xs text-muted-foreground">
              Bulk actions available
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsAdjusting(!isAdjusting)}
            iconName="Calculator"
            iconPosition="left"
          >
            Adjust
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkDelete}
            iconName="Trash2"
            iconPosition="left"
          >
            Delete
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
          >
            Clear
          </Button>
        </div>
      </div>
      {isAdjusting && (
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-sm font-medium text-foreground mb-3">
            Adjust quantity for all selected items
          </p>
          <div className="flex items-center gap-2">
            <input
              type="number"
              value={adjustAmount}
              onChange={(e) => setAdjustAmount(e?.target?.value)}
              placeholder="Enter amount (+/-)"
              className="flex-1 px-3 py-2 text-sm bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
            />
            <Button
              variant="default"
              size="sm"
              onClick={handleBulkAdjust}
              disabled={!adjustAmount}
            >
              Apply
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                setIsAdjusting(false);
                setAdjustAmount('');
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkActions;